"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var dom_1 = require("../../helpers/dom");
var Bubble_1 = __importDefault(require("../Bubble"));
var Icon_1 = __importDefault(require("../Icon"));
var Dropdown_1 = __importDefault(require("./Dropdown"));
var styles_1 = __importDefault(require("./styles"));
// tslint:disable-next-line: max-line-length
var MultiSelect = function (_a) {
    var className = _a.className, labelProp = _a.labelProp, options = _a.options, onChange = _a.onChange, placeholder = _a.placeholder, isHidden = _a.isHidden, style = _a.style, isInvalid = _a.isInvalid, isDisabled = _a.isDisabled, initialValue = _a.initialValue, form = _a.form;
    if (isHidden)
        return null;
    var ref = react_1.useRef();
    var wrapperRef = react_1.useRef();
    var _b = react_1.useState(initialValue !== null && initialValue !== void 0 ? initialValue : []), selected = _b[0], setSelected = _b[1];
    var _c = react_1.useState(false), isOpen = _c[0], setIsOpen = _c[1];
    var isDisabledOrEmpty = isDisabled || !options || !!options && !options.length;
    var classNames = "\n    " + (className || '') + "\n    " + (isOpen ? 'open' : '') + "\n    " + (isInvalid ? 'invalid' : '') + "\n    " + (isDisabledOrEmpty ? 'disabled' : '') + "\n  ";
    var values = !!selected.length
        ? selected.map(function (s, i) { return react_1.default.createElement(Bubble_1.default, { type: "primary", className: "value", key: i }, s[labelProp]); })
        : react_1.default.createElement("span", { className: "placeholder" }, placeholder);
    var handleClick = function (option) {
        var selectedOptions = !!selected.find(function (s) { return s.id === option.id; })
            ? selected.filter(function (s) { return s.id !== option.id; })
            : __spreadArrays(selected, [option]);
        setSelected(selectedOptions);
        onChange(selectedOptions);
    };
    var handleBulkSelect = function (filtered) {
        var nextSelected = selected.length > 0 ? [] : filtered || options;
        setSelected(nextSelected);
        onChange(nextSelected);
    };
    var handleDocumentClick = function (event) {
        if ((!dom_1.isChildNode(ref.current, event.target) && ref.current !== event.target) &&
            (!dom_1.isChildNode(wrapperRef.current, event.target) && wrapperRef.current !== event.target))
            setIsOpen(false);
    };
    react_1.useEffect(function () {
        if (form)
            form.addEventListener('reset', setSelected.bind(undefined, initialValue !== null && initialValue !== void 0 ? initialValue : []));
        document.addEventListener('click', handleDocumentClick);
    }, [form]);
    return (react_1.default.createElement(styles_1.default, { className: classNames, style: style, ref: ref },
        react_1.default.createElement("section", { className: "wrapper", onClick: setIsOpen.bind(undefined, !isDisabledOrEmpty && !isOpen), ref: wrapperRef },
            react_1.default.createElement("div", { className: "values" }, values),
            react_1.default.createElement(Icon_1.default, { className: "icon", icon: isOpen && !isDisabledOrEmpty ? 'up' : 'down' })),
        react_1.default.createElement(Dropdown_1.default, { isHidden: !isOpen || isDisabledOrEmpty, options: options, labelProp: labelProp, selected: selected, onClick: handleClick, onBulkSelect: handleBulkSelect })));
};
exports.default = MultiSelect;
//# sourceMappingURL=index.js.map